<template>
    <div
        class="modal-dialog modal-dialog-centered modal-dialog-scrollable"
        role="document"
    >
        <div class="modal-content">
            <div class="modal-header border-0 p-4">
                <modal-close />
                <div class="modal-title">
                    <h2 class="h3 pt-1 mb-0">Wyłączanie usługi</h2>
                </div>
            </div>
            <div class="modal-body p-4 border-top text-center">
                <h2 class="c-service__title mb-3">{{ service.name }}</h2>
                <p>
                    Aby zrezygnować z usługi, skontaktuj się z HelpDeskiem lub
                    wyślij do nas zgłoszenie mailem.
                    {{ additionalInfo }}
                </p>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    methods: {
        cancelService() {
            this.$store
                .dispatch('serviceDeactivate', {
                    serviceId: this.service.id,
                    shopIds: this.$store.getters.getAllServiceShopIds,
                    level: this.service.level,
                    singleService: this.modalState.args.singleService
                })
                .then(() => {
                    if (this.modalState.args.singleService) {
                        this.$store.dispatch('serviceFetch', this.service.id)
                    } else {
                        this.$store.dispatch('servicesFetch')
                    }
                })
        }
    },
    computed: {
        modalState() {
            return this.$store.getters.modalState
        },
        service() {
            return this.$store.getters.modalState.args.service
        },
        additionalInfo() {
            let value = ''
            if (
                this.service.code === 'pp_ms' ||
                (this.service.code === 'emka' &&
                this.$store.getters.isServiceActive('pp_ms'))
            ) {
                const linkedService = this.$store.getters.getServiceByCode(
                    this.service.code === 'pp_ms' ? 'emka' : 'pp_ms'
                )
                value = `Pamiętaj, że rezygnacja z usługi ${this.service.name} wiąże się również z wypowiedzeniem usługi ${linkedService?.name}.`
            }
            return value
        }
    }
}
</script>
